import { render } from "./HeartfullIcon.vue?vue&type=template&id=3dfc1e96&scoped=true"
import script from "./HeartfullIcon.vue?vue&type=script&lang=js"
export * from "./HeartfullIcon.vue?vue&type=script&lang=js"

import "./HeartfullIcon.vue?vue&type=style&index=0&id=3dfc1e96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfc1e96"]])

export default __exports__